import { render, staticRenderFns } from "./StudentTaskList.vue?vue&type=template&id=2ae58c1a&scoped=true"
import script from "./StudentTaskList.vue?vue&type=script&lang=js"
export * from "./StudentTaskList.vue?vue&type=script&lang=js"
import style0 from "./StudentTaskList.vue?vue&type=style&index=0&id=2ae58c1a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae58c1a",
  null
  
)

export default component.exports